import { render, staticRenderFns } from "./DragAndDropModal.vue?vue&type=template&id=d5ca0018"
import script from "./DragAndDropModal.vue?vue&type=script&setup=true&lang=js"
export * from "./DragAndDropModal.vue?vue&type=script&setup=true&lang=js"
import style0 from "./DragAndDropModal.vue?vue&type=style&index=0&id=d5ca0018&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports